"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: map_page.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapPageBoundarySearchResponse = exports.MapPageBoundarySearchRequest = exports.MapPageListing = exports.MapPageCluster = exports.PointCoordinates = exports.MapPageListingResponse = exports.MapPageClusterRequest = exports.MapPageFilter = exports.LatLonAsArray = exports.Geohash = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const area_page_1 = require("./area_page");
const standard_status_1 = require("./property/standard_status");
exports.protobufPackage = "domain";
function createBaseGeohash() {
    return { topLeft: "", bottomRight: "" };
}
exports.Geohash = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.topLeft !== "") {
            writer.uint32(10).string(message.topLeft);
        }
        if (message.bottomRight !== "") {
            writer.uint32(18).string(message.bottomRight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGeohash();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.topLeft = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.bottomRight = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            topLeft: isSet(object.topLeft) ? globalThis.String(object.topLeft) : "",
            bottomRight: isSet(object.bottomRight) ? globalThis.String(object.bottomRight) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.topLeft !== "") {
            obj.topLeft = message.topLeft;
        }
        if (message.bottomRight !== "") {
            obj.bottomRight = message.bottomRight;
        }
        return obj;
    },
    create(base) {
        return exports.Geohash.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGeohash();
        message.topLeft = (_a = object.topLeft) !== null && _a !== void 0 ? _a : "";
        message.bottomRight = (_b = object.bottomRight) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseLatLonAsArray() {
    return { topLeft: [], bottomRight: [] };
}
exports.LatLonAsArray = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        writer.uint32(10).fork();
        for (const v of message.topLeft) {
            writer.float(v);
        }
        writer.join();
        writer.uint32(18).fork();
        for (const v of message.bottomRight) {
            writer.float(v);
        }
        writer.join();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLatLonAsArray();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag === 13) {
                        message.topLeft.push(reader.float());
                        continue;
                    }
                    if (tag === 10) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.topLeft.push(reader.float());
                        }
                        continue;
                    }
                    break;
                }
                case 2: {
                    if (tag === 21) {
                        message.bottomRight.push(reader.float());
                        continue;
                    }
                    if (tag === 18) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.bottomRight.push(reader.float());
                        }
                        continue;
                    }
                    break;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            topLeft: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.topLeft) ? object.topLeft.map((e) => globalThis.Number(e)) : [],
            bottomRight: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.bottomRight)
                ? object.bottomRight.map((e) => globalThis.Number(e))
                : [],
        };
    },
    toJSON(message) {
        var _a, _b;
        const obj = {};
        if ((_a = message.topLeft) === null || _a === void 0 ? void 0 : _a.length) {
            obj.topLeft = message.topLeft;
        }
        if ((_b = message.bottomRight) === null || _b === void 0 ? void 0 : _b.length) {
            obj.bottomRight = message.bottomRight;
        }
        return obj;
    },
    create(base) {
        return exports.LatLonAsArray.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseLatLonAsArray();
        message.topLeft = ((_a = object.topLeft) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.bottomRight = ((_b = object.bottomRight) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
function createBaseMapPageFilter() {
    return {
        listingType: 0,
        statusId: 0,
        price: undefined,
        styles: [],
        listedDate: undefined,
        bedroomsExact: undefined,
        bedroomsRange: undefined,
        bathroomsExact: undefined,
        bathroomsRange: undefined,
        parkingExact: undefined,
        parkingRange: undefined,
        squareFeet: undefined,
        propertyType: [],
        hasGarage: false,
        hasPool: false,
        hasOpenHouse: false,
        hasWaterFront: false,
        hasFirePlace: false,
        hasLocker: false,
        maintenance: 0,
        providerId: 0,
        latLonAsArray: undefined,
        latLonAsGeohash: undefined,
        precision: 0,
        countryCode: "",
        typeOfProperty: [],
        hasImage: false,
        displayAddress: undefined,
        standardStatus: 0,
    };
}
exports.MapPageFilter = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.listingType !== 0) {
            writer.uint32(8).int32(message.listingType);
        }
        if (message.statusId !== 0) {
            writer.uint32(16).int32(message.statusId);
        }
        if (message.price !== undefined) {
            area_page_1.Range_Float.encode(message.price, writer.uint32(26).fork()).join();
        }
        writer.uint32(34).fork();
        for (const v of message.styles) {
            writer.int32(v);
        }
        writer.join();
        if (message.listedDate !== undefined) {
            area_page_1.Range_Date.encode(message.listedDate, writer.uint32(42).fork()).join();
        }
        if (message.bedroomsExact !== undefined) {
            writer.uint32(48).uint32(message.bedroomsExact);
        }
        if (message.bedroomsRange !== undefined) {
            area_page_1.Range_Integer.encode(message.bedroomsRange, writer.uint32(58).fork()).join();
        }
        if (message.bathroomsExact !== undefined) {
            writer.uint32(64).uint32(message.bathroomsExact);
        }
        if (message.bathroomsRange !== undefined) {
            area_page_1.Range_Integer.encode(message.bathroomsRange, writer.uint32(74).fork()).join();
        }
        if (message.parkingExact !== undefined) {
            writer.uint32(80).uint32(message.parkingExact);
        }
        if (message.parkingRange !== undefined) {
            area_page_1.Range_Integer.encode(message.parkingRange, writer.uint32(90).fork()).join();
        }
        if (message.squareFeet !== undefined) {
            area_page_1.Range_Float.encode(message.squareFeet, writer.uint32(98).fork()).join();
        }
        writer.uint32(106).fork();
        for (const v of message.propertyType) {
            writer.int32(v);
        }
        writer.join();
        if (message.hasGarage !== false) {
            writer.uint32(112).bool(message.hasGarage);
        }
        if (message.hasPool !== false) {
            writer.uint32(120).bool(message.hasPool);
        }
        if (message.hasOpenHouse !== false) {
            writer.uint32(128).bool(message.hasOpenHouse);
        }
        if (message.hasWaterFront !== false) {
            writer.uint32(136).bool(message.hasWaterFront);
        }
        if (message.hasFirePlace !== false) {
            writer.uint32(144).bool(message.hasFirePlace);
        }
        if (message.hasLocker !== false) {
            writer.uint32(152).bool(message.hasLocker);
        }
        if (message.maintenance !== 0) {
            writer.uint32(165).float(message.maintenance);
        }
        if (message.providerId !== 0) {
            writer.uint32(168).int32(message.providerId);
        }
        if (message.latLonAsArray !== undefined) {
            exports.LatLonAsArray.encode(message.latLonAsArray, writer.uint32(178).fork()).join();
        }
        if (message.latLonAsGeohash !== undefined) {
            exports.Geohash.encode(message.latLonAsGeohash, writer.uint32(186).fork()).join();
        }
        if (message.precision !== 0) {
            writer.uint32(200).uint32(message.precision);
        }
        if (message.countryCode !== "") {
            writer.uint32(210).string(message.countryCode);
        }
        for (const v of message.typeOfProperty) {
            area_page_1.TypeOfProperty.encode(v, writer.uint32(218).fork()).join();
        }
        if (message.hasImage !== false) {
            writer.uint32(224).bool(message.hasImage);
        }
        if (message.displayAddress !== undefined) {
            writer.uint32(232).bool(message.displayAddress);
        }
        if (message.standardStatus !== 0) {
            writer.uint32(240).int32(message.standardStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapPageFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.listingType = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.statusId = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.price = area_page_1.Range_Float.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag === 32) {
                        message.styles.push(reader.int32());
                        continue;
                    }
                    if (tag === 34) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.styles.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.listedDate = area_page_1.Range_Date.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.bedroomsExact = reader.uint32();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.bedroomsRange = area_page_1.Range_Integer.decode(reader, reader.uint32());
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.bathroomsExact = reader.uint32();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.bathroomsRange = area_page_1.Range_Integer.decode(reader, reader.uint32());
                    continue;
                }
                case 10: {
                    if (tag !== 80) {
                        break;
                    }
                    message.parkingExact = reader.uint32();
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.parkingRange = area_page_1.Range_Integer.decode(reader, reader.uint32());
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.squareFeet = area_page_1.Range_Float.decode(reader, reader.uint32());
                    continue;
                }
                case 13: {
                    if (tag === 104) {
                        message.propertyType.push(reader.int32());
                        continue;
                    }
                    if (tag === 106) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.propertyType.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                }
                case 14: {
                    if (tag !== 112) {
                        break;
                    }
                    message.hasGarage = reader.bool();
                    continue;
                }
                case 15: {
                    if (tag !== 120) {
                        break;
                    }
                    message.hasPool = reader.bool();
                    continue;
                }
                case 16: {
                    if (tag !== 128) {
                        break;
                    }
                    message.hasOpenHouse = reader.bool();
                    continue;
                }
                case 17: {
                    if (tag !== 136) {
                        break;
                    }
                    message.hasWaterFront = reader.bool();
                    continue;
                }
                case 18: {
                    if (tag !== 144) {
                        break;
                    }
                    message.hasFirePlace = reader.bool();
                    continue;
                }
                case 19: {
                    if (tag !== 152) {
                        break;
                    }
                    message.hasLocker = reader.bool();
                    continue;
                }
                case 20: {
                    if (tag !== 165) {
                        break;
                    }
                    message.maintenance = reader.float();
                    continue;
                }
                case 21: {
                    if (tag !== 168) {
                        break;
                    }
                    message.providerId = reader.int32();
                    continue;
                }
                case 22: {
                    if (tag !== 178) {
                        break;
                    }
                    message.latLonAsArray = exports.LatLonAsArray.decode(reader, reader.uint32());
                    continue;
                }
                case 23: {
                    if (tag !== 186) {
                        break;
                    }
                    message.latLonAsGeohash = exports.Geohash.decode(reader, reader.uint32());
                    continue;
                }
                case 25: {
                    if (tag !== 200) {
                        break;
                    }
                    message.precision = reader.uint32();
                    continue;
                }
                case 26: {
                    if (tag !== 210) {
                        break;
                    }
                    message.countryCode = reader.string();
                    continue;
                }
                case 27: {
                    if (tag !== 218) {
                        break;
                    }
                    message.typeOfProperty.push(area_page_1.TypeOfProperty.decode(reader, reader.uint32()));
                    continue;
                }
                case 28: {
                    if (tag !== 224) {
                        break;
                    }
                    message.hasImage = reader.bool();
                    continue;
                }
                case 29: {
                    if (tag !== 232) {
                        break;
                    }
                    message.displayAddress = reader.bool();
                    continue;
                }
                case 30: {
                    if (tag !== 240) {
                        break;
                    }
                    message.standardStatus = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            listingType: isSet(object.listingType) ? (0, area_page_1.areaPageListing_ListingTypeFromJSON)(object.listingType) : 0,
            statusId: isSet(object.statusId) ? (0, area_page_1.areaPageListing_StatusFromJSON)(object.statusId) : 0,
            price: isSet(object.price) ? area_page_1.Range_Float.fromJSON(object.price) : undefined,
            styles: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.styles) ? object.styles.map((e) => (0, area_page_1.styleFromJSON)(e)) : [],
            listedDate: isSet(object.listedDate) ? area_page_1.Range_Date.fromJSON(object.listedDate) : undefined,
            bedroomsExact: isSet(object.bedroomsExact) ? globalThis.Number(object.bedroomsExact) : undefined,
            bedroomsRange: isSet(object.bedroomsRange) ? area_page_1.Range_Integer.fromJSON(object.bedroomsRange) : undefined,
            bathroomsExact: isSet(object.bathroomsExact) ? globalThis.Number(object.bathroomsExact) : undefined,
            bathroomsRange: isSet(object.bathroomsRange) ? area_page_1.Range_Integer.fromJSON(object.bathroomsRange) : undefined,
            parkingExact: isSet(object.parkingExact) ? globalThis.Number(object.parkingExact) : undefined,
            parkingRange: isSet(object.parkingRange) ? area_page_1.Range_Integer.fromJSON(object.parkingRange) : undefined,
            squareFeet: isSet(object.squareFeet) ? area_page_1.Range_Float.fromJSON(object.squareFeet) : undefined,
            propertyType: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.propertyType)
                ? object.propertyType.map((e) => (0, area_page_1.propertyTypeFromJSON)(e))
                : [],
            hasGarage: isSet(object.hasGarage) ? globalThis.Boolean(object.hasGarage) : false,
            hasPool: isSet(object.hasPool) ? globalThis.Boolean(object.hasPool) : false,
            hasOpenHouse: isSet(object.hasOpenHouse) ? globalThis.Boolean(object.hasOpenHouse) : false,
            hasWaterFront: isSet(object.hasWaterFront) ? globalThis.Boolean(object.hasWaterFront) : false,
            hasFirePlace: isSet(object.hasFirePlace) ? globalThis.Boolean(object.hasFirePlace) : false,
            hasLocker: isSet(object.hasLocker) ? globalThis.Boolean(object.hasLocker) : false,
            maintenance: isSet(object.maintenance) ? globalThis.Number(object.maintenance) : 0,
            providerId: isSet(object.providerId) ? (0, area_page_1.areaPageListing_ProviderFromJSON)(object.providerId) : 0,
            latLonAsArray: isSet(object.latLonAsArray) ? exports.LatLonAsArray.fromJSON(object.latLonAsArray) : undefined,
            latLonAsGeohash: isSet(object.latLonAsGeohash) ? exports.Geohash.fromJSON(object.latLonAsGeohash) : undefined,
            precision: isSet(object.precision) ? globalThis.Number(object.precision) : 0,
            countryCode: isSet(object.countryCode) ? globalThis.String(object.countryCode) : "",
            typeOfProperty: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.typeOfProperty)
                ? object.typeOfProperty.map((e) => area_page_1.TypeOfProperty.fromJSON(e))
                : [],
            hasImage: isSet(object.hasImage) ? globalThis.Boolean(object.hasImage) : false,
            displayAddress: isSet(object.displayAddress) ? globalThis.Boolean(object.displayAddress) : undefined,
            standardStatus: isSet(object.standardStatus) ? (0, standard_status_1.standardStatusFromJSON)(object.standardStatus) : 0,
        };
    },
    toJSON(message) {
        var _a, _b, _c;
        const obj = {};
        if (message.listingType !== 0) {
            obj.listingType = (0, area_page_1.areaPageListing_ListingTypeToJSON)(message.listingType);
        }
        if (message.statusId !== 0) {
            obj.statusId = (0, area_page_1.areaPageListing_StatusToJSON)(message.statusId);
        }
        if (message.price !== undefined) {
            obj.price = area_page_1.Range_Float.toJSON(message.price);
        }
        if ((_a = message.styles) === null || _a === void 0 ? void 0 : _a.length) {
            obj.styles = message.styles.map((e) => (0, area_page_1.styleToJSON)(e));
        }
        if (message.listedDate !== undefined) {
            obj.listedDate = area_page_1.Range_Date.toJSON(message.listedDate);
        }
        if (message.bedroomsExact !== undefined) {
            obj.bedroomsExact = Math.round(message.bedroomsExact);
        }
        if (message.bedroomsRange !== undefined) {
            obj.bedroomsRange = area_page_1.Range_Integer.toJSON(message.bedroomsRange);
        }
        if (message.bathroomsExact !== undefined) {
            obj.bathroomsExact = Math.round(message.bathroomsExact);
        }
        if (message.bathroomsRange !== undefined) {
            obj.bathroomsRange = area_page_1.Range_Integer.toJSON(message.bathroomsRange);
        }
        if (message.parkingExact !== undefined) {
            obj.parkingExact = Math.round(message.parkingExact);
        }
        if (message.parkingRange !== undefined) {
            obj.parkingRange = area_page_1.Range_Integer.toJSON(message.parkingRange);
        }
        if (message.squareFeet !== undefined) {
            obj.squareFeet = area_page_1.Range_Float.toJSON(message.squareFeet);
        }
        if ((_b = message.propertyType) === null || _b === void 0 ? void 0 : _b.length) {
            obj.propertyType = message.propertyType.map((e) => (0, area_page_1.propertyTypeToJSON)(e));
        }
        if (message.hasGarage !== false) {
            obj.hasGarage = message.hasGarage;
        }
        if (message.hasPool !== false) {
            obj.hasPool = message.hasPool;
        }
        if (message.hasOpenHouse !== false) {
            obj.hasOpenHouse = message.hasOpenHouse;
        }
        if (message.hasWaterFront !== false) {
            obj.hasWaterFront = message.hasWaterFront;
        }
        if (message.hasFirePlace !== false) {
            obj.hasFirePlace = message.hasFirePlace;
        }
        if (message.hasLocker !== false) {
            obj.hasLocker = message.hasLocker;
        }
        if (message.maintenance !== 0) {
            obj.maintenance = message.maintenance;
        }
        if (message.providerId !== 0) {
            obj.providerId = (0, area_page_1.areaPageListing_ProviderToJSON)(message.providerId);
        }
        if (message.latLonAsArray !== undefined) {
            obj.latLonAsArray = exports.LatLonAsArray.toJSON(message.latLonAsArray);
        }
        if (message.latLonAsGeohash !== undefined) {
            obj.latLonAsGeohash = exports.Geohash.toJSON(message.latLonAsGeohash);
        }
        if (message.precision !== 0) {
            obj.precision = Math.round(message.precision);
        }
        if (message.countryCode !== "") {
            obj.countryCode = message.countryCode;
        }
        if ((_c = message.typeOfProperty) === null || _c === void 0 ? void 0 : _c.length) {
            obj.typeOfProperty = message.typeOfProperty.map((e) => area_page_1.TypeOfProperty.toJSON(e));
        }
        if (message.hasImage !== false) {
            obj.hasImage = message.hasImage;
        }
        if (message.displayAddress !== undefined) {
            obj.displayAddress = message.displayAddress;
        }
        if (message.standardStatus !== 0) {
            obj.standardStatus = (0, standard_status_1.standardStatusToJSON)(message.standardStatus);
        }
        return obj;
    },
    create(base) {
        return exports.MapPageFilter.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        const message = createBaseMapPageFilter();
        message.listingType = (_a = object.listingType) !== null && _a !== void 0 ? _a : 0;
        message.statusId = (_b = object.statusId) !== null && _b !== void 0 ? _b : 0;
        message.price = (object.price !== undefined && object.price !== null)
            ? area_page_1.Range_Float.fromPartial(object.price)
            : undefined;
        message.styles = ((_c = object.styles) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        message.listedDate = (object.listedDate !== undefined && object.listedDate !== null)
            ? area_page_1.Range_Date.fromPartial(object.listedDate)
            : undefined;
        message.bedroomsExact = (_d = object.bedroomsExact) !== null && _d !== void 0 ? _d : undefined;
        message.bedroomsRange = (object.bedroomsRange !== undefined && object.bedroomsRange !== null)
            ? area_page_1.Range_Integer.fromPartial(object.bedroomsRange)
            : undefined;
        message.bathroomsExact = (_e = object.bathroomsExact) !== null && _e !== void 0 ? _e : undefined;
        message.bathroomsRange = (object.bathroomsRange !== undefined && object.bathroomsRange !== null)
            ? area_page_1.Range_Integer.fromPartial(object.bathroomsRange)
            : undefined;
        message.parkingExact = (_f = object.parkingExact) !== null && _f !== void 0 ? _f : undefined;
        message.parkingRange = (object.parkingRange !== undefined && object.parkingRange !== null)
            ? area_page_1.Range_Integer.fromPartial(object.parkingRange)
            : undefined;
        message.squareFeet = (object.squareFeet !== undefined && object.squareFeet !== null)
            ? area_page_1.Range_Float.fromPartial(object.squareFeet)
            : undefined;
        message.propertyType = ((_g = object.propertyType) === null || _g === void 0 ? void 0 : _g.map((e) => e)) || [];
        message.hasGarage = (_h = object.hasGarage) !== null && _h !== void 0 ? _h : false;
        message.hasPool = (_j = object.hasPool) !== null && _j !== void 0 ? _j : false;
        message.hasOpenHouse = (_k = object.hasOpenHouse) !== null && _k !== void 0 ? _k : false;
        message.hasWaterFront = (_l = object.hasWaterFront) !== null && _l !== void 0 ? _l : false;
        message.hasFirePlace = (_m = object.hasFirePlace) !== null && _m !== void 0 ? _m : false;
        message.hasLocker = (_o = object.hasLocker) !== null && _o !== void 0 ? _o : false;
        message.maintenance = (_p = object.maintenance) !== null && _p !== void 0 ? _p : 0;
        message.providerId = (_q = object.providerId) !== null && _q !== void 0 ? _q : 0;
        message.latLonAsArray = (object.latLonAsArray !== undefined && object.latLonAsArray !== null)
            ? exports.LatLonAsArray.fromPartial(object.latLonAsArray)
            : undefined;
        message.latLonAsGeohash = (object.latLonAsGeohash !== undefined && object.latLonAsGeohash !== null)
            ? exports.Geohash.fromPartial(object.latLonAsGeohash)
            : undefined;
        message.precision = (_r = object.precision) !== null && _r !== void 0 ? _r : 0;
        message.countryCode = (_s = object.countryCode) !== null && _s !== void 0 ? _s : "";
        message.typeOfProperty = ((_t = object.typeOfProperty) === null || _t === void 0 ? void 0 : _t.map((e) => area_page_1.TypeOfProperty.fromPartial(e))) || [];
        message.hasImage = (_u = object.hasImage) !== null && _u !== void 0 ? _u : false;
        message.displayAddress = (_v = object.displayAddress) !== null && _v !== void 0 ? _v : undefined;
        message.standardStatus = (_w = object.standardStatus) !== null && _w !== void 0 ? _w : 0;
        return message;
    },
};
function createBaseMapPageClusterRequest() {
    return { sortBy: 0, filter: undefined };
}
exports.MapPageClusterRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.sortBy !== 0) {
            writer.uint32(8).int32(message.sortBy);
        }
        if (message.filter !== undefined) {
            exports.MapPageFilter.encode(message.filter, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapPageClusterRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.sortBy = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.filter = exports.MapPageFilter.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sortBy: isSet(object.sortBy) ? (0, area_page_1.sortByFromJSON)(object.sortBy) : 0,
            filter: isSet(object.filter) ? exports.MapPageFilter.fromJSON(object.filter) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sortBy !== 0) {
            obj.sortBy = (0, area_page_1.sortByToJSON)(message.sortBy);
        }
        if (message.filter !== undefined) {
            obj.filter = exports.MapPageFilter.toJSON(message.filter);
        }
        return obj;
    },
    create(base) {
        return exports.MapPageClusterRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMapPageClusterRequest();
        message.sortBy = (_a = object.sortBy) !== null && _a !== void 0 ? _a : 0;
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? exports.MapPageFilter.fromPartial(object.filter)
            : undefined;
        return message;
    },
};
function createBaseMapPageListingResponse() {
    return { clusters: [] };
}
exports.MapPageListingResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.clusters) {
            exports.MapPageCluster.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapPageListingResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.clusters.push(exports.MapPageCluster.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            clusters: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.clusters)
                ? object.clusters.map((e) => exports.MapPageCluster.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.clusters) === null || _a === void 0 ? void 0 : _a.length) {
            obj.clusters = message.clusters.map((e) => exports.MapPageCluster.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.MapPageListingResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMapPageListingResponse();
        message.clusters = ((_a = object.clusters) === null || _a === void 0 ? void 0 : _a.map((e) => exports.MapPageCluster.fromPartial(e))) || [];
        return message;
    },
};
function createBasePointCoordinates() {
    return { lat: 0, lon: 0 };
}
exports.PointCoordinates = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.lat !== 0) {
            writer.uint32(13).float(message.lat);
        }
        if (message.lon !== 0) {
            writer.uint32(21).float(message.lon);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePointCoordinates();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 13) {
                        break;
                    }
                    message.lat = reader.float();
                    continue;
                }
                case 2: {
                    if (tag !== 21) {
                        break;
                    }
                    message.lon = reader.float();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            lat: isSet(object.lat) ? globalThis.Number(object.lat) : 0,
            lon: isSet(object.lon) ? globalThis.Number(object.lon) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.lat !== 0) {
            obj.lat = message.lat;
        }
        if (message.lon !== 0) {
            obj.lon = message.lon;
        }
        return obj;
    },
    create(base) {
        return exports.PointCoordinates.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBasePointCoordinates();
        message.lat = (_a = object.lat) !== null && _a !== void 0 ? _a : 0;
        message.lon = (_b = object.lon) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseMapPageCluster() {
    return { coordinates: undefined, listings: [], count: 0, geohash: "", key: "" };
}
exports.MapPageCluster = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.coordinates !== undefined) {
            exports.PointCoordinates.encode(message.coordinates, writer.uint32(10).fork()).join();
        }
        for (const v of message.listings) {
            exports.MapPageListing.encode(v, writer.uint32(18).fork()).join();
        }
        if (message.count !== 0) {
            writer.uint32(24).int32(message.count);
        }
        if (message.geohash !== "") {
            writer.uint32(34).string(message.geohash);
        }
        if (message.key !== "") {
            writer.uint32(42).string(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapPageCluster();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.coordinates = exports.PointCoordinates.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.listings.push(exports.MapPageListing.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.count = reader.int32();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.geohash = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            coordinates: isSet(object.coordinates) ? exports.PointCoordinates.fromJSON(object.coordinates) : undefined,
            listings: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.listings)
                ? object.listings.map((e) => exports.MapPageListing.fromJSON(e))
                : [],
            count: isSet(object.count) ? globalThis.Number(object.count) : 0,
            geohash: isSet(object.geohash) ? globalThis.String(object.geohash) : "",
            key: isSet(object.key) ? globalThis.String(object.key) : "",
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.coordinates !== undefined) {
            obj.coordinates = exports.PointCoordinates.toJSON(message.coordinates);
        }
        if ((_a = message.listings) === null || _a === void 0 ? void 0 : _a.length) {
            obj.listings = message.listings.map((e) => exports.MapPageListing.toJSON(e));
        }
        if (message.count !== 0) {
            obj.count = Math.round(message.count);
        }
        if (message.geohash !== "") {
            obj.geohash = message.geohash;
        }
        if (message.key !== "") {
            obj.key = message.key;
        }
        return obj;
    },
    create(base) {
        return exports.MapPageCluster.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseMapPageCluster();
        message.coordinates = (object.coordinates !== undefined && object.coordinates !== null)
            ? exports.PointCoordinates.fromPartial(object.coordinates)
            : undefined;
        message.listings = ((_a = object.listings) === null || _a === void 0 ? void 0 : _a.map((e) => exports.MapPageListing.fromPartial(e))) || [];
        message.count = (_b = object.count) !== null && _b !== void 0 ? _b : 0;
        message.geohash = (_c = object.geohash) !== null && _c !== void 0 ? _c : "";
        message.key = (_d = object.key) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseMapPageListing() {
    return {
        id: 0,
        mls: "",
        slug: "",
        address: "",
        listingType: 0,
        price: 0,
        soldPrice: 0,
        statusId: 0,
        providerId: 0,
        position: "",
        bedrooms: 0,
        bathrooms: 0,
        brokerage: "",
        squareFootage: undefined,
        imageSource: "",
        termsOfUseRequired: false,
        imageRootStorageKey: "",
        addressUrlAbsolutePath: "",
        listingUrlAbsolutePath: "",
        expAgentId: 0,
        standardStatus: 0,
    };
}
exports.MapPageListing = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== 0) {
            writer.uint32(8).int32(message.id);
        }
        if (message.mls !== "") {
            writer.uint32(18).string(message.mls);
        }
        if (message.slug !== "") {
            writer.uint32(26).string(message.slug);
        }
        if (message.address !== "") {
            writer.uint32(34).string(message.address);
        }
        if (message.listingType !== 0) {
            writer.uint32(40).int32(message.listingType);
        }
        if (message.price !== 0) {
            writer.uint32(53).float(message.price);
        }
        if (message.soldPrice !== 0) {
            writer.uint32(61).float(message.soldPrice);
        }
        if (message.statusId !== 0) {
            writer.uint32(64).int32(message.statusId);
        }
        if (message.providerId !== 0) {
            writer.uint32(72).int32(message.providerId);
        }
        if (message.position !== "") {
            writer.uint32(82).string(message.position);
        }
        if (message.bedrooms !== 0) {
            writer.uint32(88).uint64(message.bedrooms);
        }
        if (message.bathrooms !== 0) {
            writer.uint32(96).uint64(message.bathrooms);
        }
        if (message.brokerage !== "") {
            writer.uint32(106).string(message.brokerage);
        }
        if (message.squareFootage !== undefined) {
            area_page_1.AreaPageListing_IntegerRange.encode(message.squareFootage, writer.uint32(114).fork()).join();
        }
        if (message.imageSource !== "") {
            writer.uint32(122).string(message.imageSource);
        }
        if (message.termsOfUseRequired !== false) {
            writer.uint32(128).bool(message.termsOfUseRequired);
        }
        if (message.imageRootStorageKey !== "") {
            writer.uint32(138).string(message.imageRootStorageKey);
        }
        if (message.addressUrlAbsolutePath !== "") {
            writer.uint32(146).string(message.addressUrlAbsolutePath);
        }
        if (message.listingUrlAbsolutePath !== "") {
            writer.uint32(154).string(message.listingUrlAbsolutePath);
        }
        if (message.expAgentId !== 0) {
            writer.uint32(160).uint64(message.expAgentId);
        }
        if (message.standardStatus !== 0) {
            writer.uint32(168).int32(message.standardStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapPageListing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.id = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.mls = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.slug = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.address = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.listingType = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 53) {
                        break;
                    }
                    message.price = reader.float();
                    continue;
                }
                case 7: {
                    if (tag !== 61) {
                        break;
                    }
                    message.soldPrice = reader.float();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.statusId = reader.int32();
                    continue;
                }
                case 9: {
                    if (tag !== 72) {
                        break;
                    }
                    message.providerId = reader.int32();
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.position = reader.string();
                    continue;
                }
                case 11: {
                    if (tag !== 88) {
                        break;
                    }
                    message.bedrooms = longToNumber(reader.uint64());
                    continue;
                }
                case 12: {
                    if (tag !== 96) {
                        break;
                    }
                    message.bathrooms = longToNumber(reader.uint64());
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.brokerage = reader.string();
                    continue;
                }
                case 14: {
                    if (tag !== 114) {
                        break;
                    }
                    message.squareFootage = area_page_1.AreaPageListing_IntegerRange.decode(reader, reader.uint32());
                    continue;
                }
                case 15: {
                    if (tag !== 122) {
                        break;
                    }
                    message.imageSource = reader.string();
                    continue;
                }
                case 16: {
                    if (tag !== 128) {
                        break;
                    }
                    message.termsOfUseRequired = reader.bool();
                    continue;
                }
                case 17: {
                    if (tag !== 138) {
                        break;
                    }
                    message.imageRootStorageKey = reader.string();
                    continue;
                }
                case 18: {
                    if (tag !== 146) {
                        break;
                    }
                    message.addressUrlAbsolutePath = reader.string();
                    continue;
                }
                case 19: {
                    if (tag !== 154) {
                        break;
                    }
                    message.listingUrlAbsolutePath = reader.string();
                    continue;
                }
                case 20: {
                    if (tag !== 160) {
                        break;
                    }
                    message.expAgentId = longToNumber(reader.uint64());
                    continue;
                }
                case 21: {
                    if (tag !== 168) {
                        break;
                    }
                    message.standardStatus = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            mls: isSet(object.mls) ? globalThis.String(object.mls) : "",
            slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
            address: isSet(object.address) ? globalThis.String(object.address) : "",
            listingType: isSet(object.listingType) ? (0, area_page_1.areaPageListing_ListingTypeFromJSON)(object.listingType) : 0,
            price: isSet(object.price) ? globalThis.Number(object.price) : 0,
            soldPrice: isSet(object.soldPrice) ? globalThis.Number(object.soldPrice) : 0,
            statusId: isSet(object.statusId) ? (0, area_page_1.areaPageListing_StatusFromJSON)(object.statusId) : 0,
            providerId: isSet(object.providerId) ? (0, area_page_1.areaPageListing_ProviderFromJSON)(object.providerId) : 0,
            position: isSet(object.position) ? globalThis.String(object.position) : "",
            bedrooms: isSet(object.bedrooms) ? globalThis.Number(object.bedrooms) : 0,
            bathrooms: isSet(object.bathrooms) ? globalThis.Number(object.bathrooms) : 0,
            brokerage: isSet(object.brokerage) ? globalThis.String(object.brokerage) : "",
            squareFootage: isSet(object.square_footage)
                ? area_page_1.AreaPageListing_IntegerRange.fromJSON(object.square_footage)
                : undefined,
            imageSource: isSet(object.image_source) ? globalThis.String(object.image_source) : "",
            termsOfUseRequired: isSet(object.terms_of_use_required)
                ? globalThis.Boolean(object.terms_of_use_required)
                : false,
            imageRootStorageKey: isSet(object.image_root_storage_key) ? globalThis.String(object.image_root_storage_key) : "",
            addressUrlAbsolutePath: isSet(object.addressUrlAbsolutePath)
                ? globalThis.String(object.addressUrlAbsolutePath)
                : "",
            listingUrlAbsolutePath: isSet(object.listingUrlAbsolutePath)
                ? globalThis.String(object.listingUrlAbsolutePath)
                : "",
            expAgentId: isSet(object.expAgentId) ? globalThis.Number(object.expAgentId) : 0,
            standardStatus: isSet(object.standardStatus) ? (0, standard_status_1.standardStatusFromJSON)(object.standardStatus) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.mls !== "") {
            obj.mls = message.mls;
        }
        if (message.slug !== "") {
            obj.slug = message.slug;
        }
        if (message.address !== "") {
            obj.address = message.address;
        }
        if (message.listingType !== 0) {
            obj.listingType = (0, area_page_1.areaPageListing_ListingTypeToJSON)(message.listingType);
        }
        if (message.price !== 0) {
            obj.price = message.price;
        }
        if (message.soldPrice !== 0) {
            obj.soldPrice = message.soldPrice;
        }
        if (message.statusId !== 0) {
            obj.statusId = (0, area_page_1.areaPageListing_StatusToJSON)(message.statusId);
        }
        if (message.providerId !== 0) {
            obj.providerId = (0, area_page_1.areaPageListing_ProviderToJSON)(message.providerId);
        }
        if (message.position !== "") {
            obj.position = message.position;
        }
        if (message.bedrooms !== 0) {
            obj.bedrooms = Math.round(message.bedrooms);
        }
        if (message.bathrooms !== 0) {
            obj.bathrooms = Math.round(message.bathrooms);
        }
        if (message.brokerage !== "") {
            obj.brokerage = message.brokerage;
        }
        if (message.squareFootage !== undefined) {
            obj.square_footage = area_page_1.AreaPageListing_IntegerRange.toJSON(message.squareFootage);
        }
        if (message.imageSource !== "") {
            obj.image_source = message.imageSource;
        }
        if (message.termsOfUseRequired !== false) {
            obj.terms_of_use_required = message.termsOfUseRequired;
        }
        if (message.imageRootStorageKey !== "") {
            obj.image_root_storage_key = message.imageRootStorageKey;
        }
        if (message.addressUrlAbsolutePath !== "") {
            obj.addressUrlAbsolutePath = message.addressUrlAbsolutePath;
        }
        if (message.listingUrlAbsolutePath !== "") {
            obj.listingUrlAbsolutePath = message.listingUrlAbsolutePath;
        }
        if (message.expAgentId !== 0) {
            obj.expAgentId = Math.round(message.expAgentId);
        }
        if (message.standardStatus !== 0) {
            obj.standardStatus = (0, standard_status_1.standardStatusToJSON)(message.standardStatus);
        }
        return obj;
    },
    create(base) {
        return exports.MapPageListing.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        const message = createBaseMapPageListing();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        message.mls = (_b = object.mls) !== null && _b !== void 0 ? _b : "";
        message.slug = (_c = object.slug) !== null && _c !== void 0 ? _c : "";
        message.address = (_d = object.address) !== null && _d !== void 0 ? _d : "";
        message.listingType = (_e = object.listingType) !== null && _e !== void 0 ? _e : 0;
        message.price = (_f = object.price) !== null && _f !== void 0 ? _f : 0;
        message.soldPrice = (_g = object.soldPrice) !== null && _g !== void 0 ? _g : 0;
        message.statusId = (_h = object.statusId) !== null && _h !== void 0 ? _h : 0;
        message.providerId = (_j = object.providerId) !== null && _j !== void 0 ? _j : 0;
        message.position = (_k = object.position) !== null && _k !== void 0 ? _k : "";
        message.bedrooms = (_l = object.bedrooms) !== null && _l !== void 0 ? _l : 0;
        message.bathrooms = (_m = object.bathrooms) !== null && _m !== void 0 ? _m : 0;
        message.brokerage = (_o = object.brokerage) !== null && _o !== void 0 ? _o : "";
        message.squareFootage = (object.squareFootage !== undefined && object.squareFootage !== null)
            ? area_page_1.AreaPageListing_IntegerRange.fromPartial(object.squareFootage)
            : undefined;
        message.imageSource = (_p = object.imageSource) !== null && _p !== void 0 ? _p : "";
        message.termsOfUseRequired = (_q = object.termsOfUseRequired) !== null && _q !== void 0 ? _q : false;
        message.imageRootStorageKey = (_r = object.imageRootStorageKey) !== null && _r !== void 0 ? _r : "";
        message.addressUrlAbsolutePath = (_s = object.addressUrlAbsolutePath) !== null && _s !== void 0 ? _s : "";
        message.listingUrlAbsolutePath = (_t = object.listingUrlAbsolutePath) !== null && _t !== void 0 ? _t : "";
        message.expAgentId = (_u = object.expAgentId) !== null && _u !== void 0 ? _u : 0;
        message.standardStatus = (_v = object.standardStatus) !== null && _v !== void 0 ? _v : 0;
        return message;
    },
};
function createBaseMapPageBoundarySearchRequest() {
    return { sortBy: 0, filter: undefined };
}
exports.MapPageBoundarySearchRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.sortBy !== 0) {
            writer.uint32(8).int32(message.sortBy);
        }
        if (message.filter !== undefined) {
            exports.MapPageFilter.encode(message.filter, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapPageBoundarySearchRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.sortBy = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.filter = exports.MapPageFilter.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sortBy: isSet(object.sortBy) ? (0, area_page_1.sortByFromJSON)(object.sortBy) : 0,
            filter: isSet(object.filter) ? exports.MapPageFilter.fromJSON(object.filter) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sortBy !== 0) {
            obj.sortBy = (0, area_page_1.sortByToJSON)(message.sortBy);
        }
        if (message.filter !== undefined) {
            obj.filter = exports.MapPageFilter.toJSON(message.filter);
        }
        return obj;
    },
    create(base) {
        return exports.MapPageBoundarySearchRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMapPageBoundarySearchRequest();
        message.sortBy = (_a = object.sortBy) !== null && _a !== void 0 ? _a : 0;
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? exports.MapPageFilter.fromPartial(object.filter)
            : undefined;
        return message;
    },
};
function createBaseMapPageBoundarySearchResponse() {
    return { listings: [], pageSize: 0, totalCount: 0, totalPages: 0, nextPage: "" };
}
exports.MapPageBoundarySearchResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.listings) {
            area_page_1.AreaPageListing.encode(v, writer.uint32(10).fork()).join();
        }
        if (message.pageSize !== 0) {
            writer.uint32(16).uint32(message.pageSize);
        }
        if (message.totalCount !== 0) {
            writer.uint32(24).uint32(message.totalCount);
        }
        if (message.totalPages !== 0) {
            writer.uint32(32).uint32(message.totalPages);
        }
        if (message.nextPage !== "") {
            writer.uint32(42).string(message.nextPage);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapPageBoundarySearchResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.listings.push(area_page_1.AreaPageListing.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.pageSize = reader.uint32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.totalCount = reader.uint32();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.totalPages = reader.uint32();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.nextPage = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            listings: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.listings)
                ? object.listings.map((e) => area_page_1.AreaPageListing.fromJSON(e))
                : [],
            pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
            totalCount: isSet(object.totalCount) ? globalThis.Number(object.totalCount) : 0,
            totalPages: isSet(object.totalPages) ? globalThis.Number(object.totalPages) : 0,
            nextPage: isSet(object.nextPage) ? globalThis.String(object.nextPage) : "",
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.listings) === null || _a === void 0 ? void 0 : _a.length) {
            obj.listings = message.listings.map((e) => area_page_1.AreaPageListing.toJSON(e));
        }
        if (message.pageSize !== 0) {
            obj.pageSize = Math.round(message.pageSize);
        }
        if (message.totalCount !== 0) {
            obj.totalCount = Math.round(message.totalCount);
        }
        if (message.totalPages !== 0) {
            obj.totalPages = Math.round(message.totalPages);
        }
        if (message.nextPage !== "") {
            obj.nextPage = message.nextPage;
        }
        return obj;
    },
    create(base) {
        return exports.MapPageBoundarySearchResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseMapPageBoundarySearchResponse();
        message.listings = ((_a = object.listings) === null || _a === void 0 ? void 0 : _a.map((e) => area_page_1.AreaPageListing.fromPartial(e))) || [];
        message.pageSize = (_b = object.pageSize) !== null && _b !== void 0 ? _b : 0;
        message.totalCount = (_c = object.totalCount) !== null && _c !== void 0 ? _c : 0;
        message.totalPages = (_d = object.totalPages) !== null && _d !== void 0 ? _d : 0;
        message.nextPage = (_e = object.nextPage) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=map_page.js.map